import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { MenuAccessService } from 'projects/shared/src/lib/permissions/menu-access.service';
import {
  isMenuUtilityRoute,
  menuPath,
  requiredMenuPermission,
} from 'projects/shared/src/lib/permissions/menu-access';

export const userMenuGuard: CanActivateFn & CanActivateChildFn = (route, state) => {
  const access = inject(MenuAccessService);
  const router = inject(Router);
  if (isMenuUtilityRoute(state.url)) return true;
  let target = state.root;
  while (target.firstChild) target = target.firstChild;
  const path = target.data['menuPath'] || state.url;
  const operation = target.pathFromRoot.some(
    (snapshot) =>
      snapshot.data['menuPermission'] === 'edit' ||
      requiredMenuPermission('', snapshot.data['type']) === 'edit',
  )
    ? 'edit'
    : requiredMenuPermission(state.url);
  // The authenticated company page has its own view-access rules. Do not exempt
  // its write actions or other routes that reuse the company detail component.
  if (menuPath(state.url) === '/company/show' && operation === 'view') return true;
  const check = () => access.allows(path, operation) || router.createUrlTree(['/access-denied']);
  return access.ready() ? check() : access.ready$.pipe(filter(Boolean), take(1), map(check));
};
